import React, { FC } from 'react';

type IProps = {
    firsName?: string;
    lastName?: string;
};

const Avatar: FC<IProps> = ({ firsName = ``, lastName = `` }) => {
    const firstNameInitial = firsName[0]?.toUpperCase() || ``;
    const lastNameInitial = lastName[0]?.toUpperCase() || ``;

    return (
        <span className="size-48 rounded-full bg-slate-200 p-2 text-lg font-extrabold text-custom-500">
            {firstNameInitial}
            {lastNameInitial}
        </span>
    );
};

export default Avatar;
